<template>
    <FormBox header="Weitere Angaben zum Werk">
        <div class="row">
            <div class="col-12 col-xl-6">
                <FormSelect
                    v-model="form.language"
                    :options="payload.languages"
                    option-value="uid"
                    option-label="name"
                    label="Sprache"
                    tooltip="language"
                    placeholder="Sprache auswählen"
                    :required="true"
                    :can-create="true"
                />
            </div>
            <div class="col-12 col-md-6 col-xl-3">
                <FormField
                    v-model="form.pages"
                    label="Seite(n)"
                    tooltip="pages"
                    placeholder="Seitenangabe"
                    :recommended="true"
                    type="number"
                    :min="0"
                    :step="1"
                />
            </div>
            <div class="col-12 col-md-6 col-xl-3">
                <FormField
                    v-model="form.year"
                    label="Erscheinungsjahr"
                    tooltip="year"
                    placeholder="Jahr"
                    :required="true"
                    :readonly="isBeitrag"
                    type="number"
                    :min="0"
                    :step="1"
                />
            </div>
        </div>

        <FormField
            v-model="form.url"
            label="URL des Volltextes"
            tooltip="url"
            placeholder="URL des Volltextes eingeben"
            :highlight="true"
            :recommended="hasOnlineMediaType"
        />
        <FormField
            v-model="form.url2"
            label="Verwandte URL"
            tooltip="url2"
            placeholder="Verwandte URL eingeben"
        />
        <FormField
            v-model="form.url2Addition"
            label="Zusatz der Verwandten URL"
            tooltip="url2Addition"
            placeholder="Zusatz eingeben"
        />
        <FormField
            v-model="form.universityWriting"
            label="Hochschulschriftenvermerk"
            tooltip="universityWriting"
            placeholder="Hochschulschriftenvermerk eingeben"
        />

        <div class="row">
            <div class="col-12 col-lg-9">
                <FormSelect
                    v-model="form.editionType"
                    :options="payload.editionTypes"
                    option-value="uid"
                    option-label="name"
                    label="Auflage-/Ausgabenbezeichnung"
                    tooltip="editionType"
                    placeholder="Auflage-/Ausgabenbezeichnung auswählen"
                    :can-create="true"
                    :readonly="isBeitrag"
                />
            </div>
            <div class="col-12 col-lg-3">
                <FormField
                    v-model="form.edition"
                    label="Nummer der Auflage"
                    tooltip="edition"
                    placeholder="Nummer der Auflage eingeben"
                    :readonly="isBeitrag"
                    type="number"
                    :min="0"
                    :step="1"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <FormField
                    v-model="form.doi"
                    label="DOI"
                    tooltip="doi"
                    placeholder="DOI eingeben"
                    :highlight="true"
                />
            </div>
            <div class="col-12 col-md-6 col-xl-3">
                <FormField
                    v-model="form.urn"
                    label="URN"
                    tooltip="urn"
                    placeholder="URN eingeben"
                />
            </div>
            <div class="col-12 col-md-6 col-xl-3">
                <FormField
                    v-model="form.issn"
                    label="ISSN"
                    tooltip="issn"
                    placeholder="ISSN eingeben"
                />
            </div>
        </div>

        <FormTextarea
            v-model="form.abstract"
            label="Abstract"
            tooltip="abstract"
            placeholder="Abstract eingeben"
            :rows="10"
        />
        <FormField
            v-model="form.attachedWork"
            label="beigefügtes Werk"
            tooltip="attachedWork"
            placeholder="beigefügtes Werk eingeben"
        />
        <FormField
            v-model="form.attached"
            label="Beigaben"
            tooltip="attached"
            placeholder="Beigaben eingeben"
        />
        <FormField
            v-model="form.addionalInformation"
            label="Zusatzinformationen"
            tooltip="addionalInformation"
            placeholder="Zusatzinformationen eingeben"
        />
        <FormCheckbox
            v-model="form.onlyWaldorf"
            label="Nur Waldorf"
            tooltip="onlyWaldorf"
            id="check-only-waldorf"
        />
    </FormBox>
</template>

<script setup>
import {computed} from 'vue';
import FormBox from './FormBox.vue';
import FormField from './FormField.vue';
import FormSelect from './FormSelect.vue';
import FormTextarea from './FormTextarea.vue';
import FormCheckbox from './FormCheckbox.vue';
import {MediaType, PublicationType} from '../publicationTypes';

const props = defineProps({
    form: { type: Object, required: true },
    payload: { type: Object, required: true },
    currentType: { type: [Number, String], required: true },
});

/** URL field should be recommended when "online" media type (UID 2) is selected */
const hasOnlineMediaType = computed(() => {
    return props.form.mediaTypes.some(mt => Number(mt) === MediaType.Online);
});

/** For Sammelwerksbeitrag: year/edition/editionType are inherited from the parent Sammelwerk. */
const isBeitrag = computed(() => Number(props.currentType) === PublicationType.Sammelwerksbeitrag);
</script>
